import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { CustomHistoryModel } from "../model/CustomHistoryModel.js";

export default {
    apiHistory: function (token, historyParams) {
        var url = `${Vue.bzbsConfig.bzbsModuleUrl}/redeem`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, token, historyParams)
                .then(response => {
                    var historyList = [];
                    for (var item of response.data) {
                        var newItem = new CustomHistoryModel();
                        newItem.setDataFromApi(item, historyParams.mode);
                        historyList.push(newItem);
                    }

                    resolve(historyList);
                }).catch(error => {
                    reject(error);
                });
        });
    },
    apiRedeemUse: function (token, redeemKey) {
        var url = `${Vue.bzbsConfig.bzbsUrl}/redeem/${redeemKey}/use`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}
